<template>
    <div class="w-full mb-6 mt-12" v-if="questions && questions.length > 0">
        <div class="orc-vert-limit-content py-6">
            <h1 class="text-2xl mb-6"><i class="el-icon-chat-dot-square mr-3"></i>Veelgestelde Vragen</h1>

            <el-collapse v-model="activeName" accordion>
                <el-collapse-item v-for="question in questions" :key="question.id" :title="question.title" :name="question.id">
                    <div class="py-4">
                        <content-displayer :current="question.answer"></content-displayer>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>

<script>
    import ContentDisplayer from "../content/ContentDisplayer";
    export default {
        name: "Questions",
        props: ['branchId'],
        components: {
            ContentDisplayer
        },
        watch: {
            branchId: function (newVal, val) {
                this.getQuestions()
            }
        },
        data() {
            return {
                activeName: '1',
                questions: this.getQuestions()
            }
        },
        methods: {
            getQuestions() {
                this.$http.get(`questions?branch=${this.branchId}`).then((response) => {
                    this.questions = response.data
                }).catch(function (error) {
                    console.log(error)
                })
            }
        }
    }
</script>

<style scoped>
    .orc-custom p {
        background-color: red;
        margin: 5px 0 5px 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/home/faq/Questions.vue